import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    PopoverFooterRadiusConstantType,
    PopoverFooterDynamicStyleType,
    PopoverFooterSizeConstantType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    PopoverFooterAlign
} from "../../type";
import {
    concentric
} from "../../../../helpers/theme/concentric";

export const POPOVER_FOOTER_JUSTIFY: Record<PopoverFooterAlign, ViewStyle["justifyContent"]> = {
    between: "space-between",
    stretch: "flex-start",
    end: "flex-end"
};

export const getPopoverFooterSize = ({
    pointerType,
    isSheet
}: PopoverFooterSizeConstantType) => {
    return isSheet || pointerType === "coarse" ? "large" : "small";
};

export const getPopoverFooterRadius = ({
    radiuses,
    borders,
    spaces
}: PopoverFooterRadiusConstantType): number => {
    return concentric({
        inset: spaces.spacingMd + borders.line,
        outer: radiuses.surface,
        role: radiuses.actions
    });
};

const stylesheet = StyleSheet.create({
    footer: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    stretch: {
        flexBasis: 0,
        flexGrow: 1
    }
});

export const useStyles = ({
    isDivided,
    borders,
    colors,
    spaces,
    align
}: PopoverFooterDynamicStyleType) => {
    const styles = {
        footer: {
            justifyContent: POPOVER_FOOTER_JUSTIFY[align],
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(isDivided) {
        Object.assign(styles.footer, {
            borderTopColor: colors.content.border.subtle,
            marginHorizontal: -spaces.spacingMd,
            paddingHorizontal: spaces.spacingMd,
            borderTopWidth: borders.separator,
            paddingTop: spaces.spacingMd
        });
    }

    return styles;
};
export default stylesheet;
